export const formFieldModelEdit = {
    formId: 'editAusenciaEmpleadoForm',
    formField: {
        empleado_id: {
            name: 'e_empleado_id',
            label: 'Empleado',
            errorMsg: 'El empleado es requerido'
        },
        absence_type: {
            name: 'e_absence_type',
            label: 'Tipo de Ausencia',
            errorMsg: 'El tipo de ausencia es requerido'
        },
        start_date: {
            name: 'e_start_date',
            label: 'Fecha de Inicio',
            errorMsg: 'La fecha de inicio es requerida'
        },
        end_date: {
            name: 'e_end_date',
            label: 'Fecha de Fin',
            errorMsg: 'La fecha de fin es requerida'
        },
        description: {
            name: 'e_description',
            label: 'Descripción',
            errorMsg: 'La descripción es requerida'
        },
        certificate_url: {
            name: 'e_certificate_url',
            label: 'Documento (Opcional)'
        },
        approval_status: {
            name: 'e_approval_status',
            label: 'Estado',
            errorMsg: 'El estado es requerido'
        }
    }
};
